import {
  ADD_SETTINGS,
  DELETE_SETTING,
  DELETE_SETTINGS,
  SET_SETTINGS,
  SettingsAction,
} from "../types";
import { Dashboard, DataType, Sorting } from "./../../types";

import { Settings } from "../../types";

const initialState: Settings | null = {
  dashboard: Dashboard.Chart,
  date: null,
  sort: DataType.Name,
  order: Sorting.Decremental,
};

export default (
  state: Settings | null = initialState,
  action: SettingsAction
) => {
  switch (action.type) {
    case SET_SETTINGS:
      return action.payload;
    case ADD_SETTINGS:
      return { ...state, ...action.payload };
    case DELETE_SETTING:
      if (state && action.payload in state) {
        let newState = { ...state };
        delete newState[action.payload as "dashboard"];
        return newState;
      } else {
        return state;
      }
    case DELETE_SETTINGS:
      return null;
    default:
      return state;
  }
};
